import { useState, useEffect } from "react";

function useAuth0Session() {
    const [isAuthenticated, setIsAuthenticated] = useState(undefined);

    useEffect(() => {
        let intervalId;

        const checkAuth0Client = async () => {
            if (window.auth0Client) {
                const _isAuthenticated = await window.auth0Client.isAuthenticated();
                console.log("IS AUTH", _isAuthenticated);
                if (typeof _isAuthenticated === "boolean") {
                    setIsAuthenticated(_isAuthenticated);
                }
                clearInterval(intervalId); // Clear the interval once we have the auth0Client
            }
        };

        // Check immediately in case the auth0Client is already loaded
        checkAuth0Client();

        // Polling to check if auth0Client becomes available
        intervalId = setInterval(() => {
            checkAuth0Client();
        }, 1000); // You can adjust the interval time

        return () => clearInterval(intervalId); // Cleanup the interval on unmount
    }, []); // We no longer track window.auth0Client as a dependency

    return isAuthenticated;
}

export default useAuth0Session;
